import * as React from "react";
import { Destination } from "../useFormRouteBuilder";
import { Segmented } from "./RouteCard";

interface Props {
  destination: Destination;
  onChange: (destination: Destination) => void;
}

export function DestinationPicker({ destination, onChange }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">Building for</span>
        <Segmented
          label="Building for"
          value={destination}
          onChange={onChange}
          options={[
            { value: "totalexpert", label: "TotalExpert" },
            { value: "crm", label: "Another CRM" },
            { value: "website", label: "Website" },
          ]}
        />
      </div>
    </div>
  );
}
